// Arte oficial: https://www.compra-agora.com/Compre_Ahora-kxs.svg.
// Mantida localmente para carregar sem depender de um domínio externo.
import {useState} from 'react'

interface LogoImagemProps {
  height?: number
}

export function LogoImagem({height = 40}: LogoImagemProps) {
  const [remota, setRemota] = useState(false)
  return (
    <img
      src={
        remota
          ? 'https://www.compra-agora.com/Compre_Ahora-kxs.svg'
          : `${process.env.PUBLIC_URL || ''}/logo-compra-agora.svg`
      }
      alt='Compra Agora'
      width={120}
      height={40}
      style={{height, width: height * 3, maxWidth: '100%', objectFit: 'contain', display: 'block'}}
      onError={() => {
        if (!remota) setRemota(true)
      }}
    />
  )
}
